import type { AbilityBuilder } from '@casl/ability'
import type { AppAbility } from '~/types/authorization.type'
import type { User } from '~/types/user.type'

export function defineSettingsAbilities(abilityBuilder: AbilityBuilder<AppAbility>, _user: User) {
  const { can } = abilityBuilder

  can('read', 'settings')
}
